import {ForecastMapConfig} from '../../api/types';

export type ModelGroup = {
  model: string;
  configs: ForecastMapConfig[];
};

/**
 * The "by model" browse (#49): the uncropped (full-domain,
 * `parameters.extent == null`) configs grouped by forecast model, in catalog
 * order. Cropped configs carry an extent and are browsed "by zone" (#50)
 * instead. Includes the non-interactive full-domain maps that the interactive
 * picker (#48) hides.
 */
export const groupUncroppedByModel = (
  configs: ForecastMapConfig[],
): ModelGroup[] => {
  const groups: ModelGroup[] = [];
  const byModel = new Map<string, ModelGroup>();
  for (const config of configs) {
    const {extent} = config.parameters;
    if (extent !== null && extent !== undefined) {
      continue; // cropped → belongs to the "by zone" browse
    }
    const name = config.forecast_model.name;
    let group = byModel.get(name);
    if (group === undefined) {
      group = {model: name, configs: []};
      byModel.set(name, group);
      groups.push(group);
    }
    group.configs.push(config);
  }
  return groups;
};
